import Model from "./abstract/Model";
import Address from "./Address";

export const PriceType = {
  FIRST_WEEK: 'FIRST_WEEK',
  SECOND_WEEK: 'SECOND_WEEK',
  AFTER_SECOND_WEEK: 'AFTER_SECOND_WEEK',
  DEPLOYMENT_TT_1: 'DEPLOYMENT_TT_1',
  DEPLOYMENT_TT_2: 'DEPLOYMENT_TT_2',
  DEPLOYMENT_FOREIGN_TT_1: 'DEPLOYMENT_FOREIGN_TT_1',
  DEPLOYMENT_FOREIGN_TT_2: 'DEPLOYMENT_FOREIGN_TT_1',
}

export default class Price extends Model {
  type;
  price;
  data;
  unit;

  constructor(props) {
    super();
    this.initializeAttributes(props);
  }
}
